import { render, staticRenderFns } from "./parking.vue?vue&type=template&id=2b867861&scoped=true&"
import script from "./parking.vue?vue&type=script&lang=js&"
export * from "./parking.vue?vue&type=script&lang=js&"
import style0 from "./parking.vue?vue&type=style&index=0&id=2b867861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b867861",
  null
  
)

export default component.exports